import { IAPCoursesDatasource } from '../datasources/ap_courses_datasource';
import { IAPPlannedCourseDataSource } from '../datasources/ap_planned_course_datasource';
import { IAPPlannedCourseGroupDatasource } from '../datasources/ap_planned_course_group_datasource';
import { IAPProgramSlotDatasource } from '../datasources/ap_program_slot_datasource';
import { IAPSectionTypeDatasource } from '../datasources/ap_section_type_datasource';
import { IAPTermsDatasource } from '../datasources/ap_terms_datasource';
import { APValidator } from './ap_validator';

export class VerifyAcademicPlanData {
  constructor(
    private ngAPCoursesDatasource: IAPCoursesDatasource,
    private ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
    private ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
    private ngAPTermsDatasource: IAPTermsDatasource,
    private ngAPSectionTypeDatasource: IAPSectionTypeDatasource,
    private ngAPPlannedCourseGroupDatasource: IAPPlannedCourseGroupDatasource,
    private ngAPValidator: APValidator
  ) {}

  verify() {
    const plannedCourseValidationGroupName = 'AcademicPlan API: Planned Course data verification failed';
    const plannedCourseDataValidator = this.ngAPValidator.validate(
      this.ngAPPlannedCoursesDatasource.values(),
      {
        course: {
          data: this.ngAPCoursesDatasource.values(),
          type: 'ONE_TO_ONE',
          key: 'id'
        },
        program_slot: {
          data: this.ngAPProgramSlotDatasource.values(),
          type: 'NO_DUPLICATES',
          key: 'id',
          whiteListValueSet: new Set([null])
        },
        term: {
          data: this.ngAPTermsDatasource.values(),
          type: 'ONE_TO_ONE',
          key: 'id'
        }
      },
      plannedCourseValidationGroupName
    );

    const plannedCourseGroupValidationGroupName = 'AcademicPlan API: Planned Course Group data verification failed';
    const plannedCourseGroupValidator = this.ngAPValidator.validate(
      this.ngAPPlannedCourseGroupDatasource.values(),
      {
        program_slot: {
          type: 'ONE_TO_ONE',
          key: 'id',
          data: this.ngAPProgramSlotDatasource.values()
        },
        term: {
          type: 'ONE_TO_ONE',
          key: 'id',
          data: this.ngAPTermsDatasource.values()
        }
      },
      plannedCourseGroupValidationGroupName
    );

    return Promise.all([plannedCourseDataValidator, plannedCourseGroupValidator]);
  }
}

angular.module('capability-ng-academic-planner').service('ngAPVerifyAcademicPlanData', VerifyAcademicPlanData);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/validators/verify_academic_plan_data.ts